module.exports = __webpack_public_path__ + "img/icon-number-one.b680f551.svg";